var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex gap-2" }, [
    _c("div", { staticClass: "flex flex-col items-center gap-1 h-full pt-1" }, [
      _vm.isFirst
        ? _c(
            "div",
            {
              staticClass:
                "rounded-full h-4 w-4 flex-shrink-0 bg-light-purple-100 flex items-center justify-center"
            },
            [
              _c("div", {
                staticClass:
                  "rounded-full h-2 w-2 flex-shrink-0 bg-light-purple"
              })
            ]
          )
        : _c(
            "div",
            {
              staticClass:
                "rounded-full h-4 w-4 flex-shrink-0 flex items-center justify-center"
            },
            [
              _c("div", {
                staticClass: "rounded-full h-2 w-2 flex-shrink-0 bg-slate-500"
              })
            ]
          ),
      _vm._v(" "),
      !_vm.isLast
        ? _c("div", {
            staticClass: "w-0.5 rounded bg-slate-400",
            style: { height: _vm.lineHeight }
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "flex flex-col",
        attrs: { id: "activity_" + _vm.activity.id }
      },
      [
        _c(
          "div",
          { staticClass: "mb-1" },
          [_c("BlTextBody2", { attrs: { text: _vm.createdAt } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-3" },
          [
            _c("BlTextBody2", {
              staticClass: "text-slate-1000",
              attrs: { text: _vm.title }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.activity.current_data
          ? _c(
              "div",
              { staticClass: "mb-3 flex flex-col gap-1" },
              [
                _vm.activity.previous_data
                  ? _c("BlTextBody2", {
                      staticClass: "line-through",
                      attrs: { text: _vm.activity.previous_data }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("BlTextBody2", {
                  attrs: { text: _vm.activity.current_data }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.complementaryInformation
          ? _c(
              "div",
              { staticClass: "mb-3 flex flex-col gap-1" },
              [
                _c("BlTextBody2", {
                  attrs: { text: _vm.complementaryInformation }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.activity.current_status
          ? _c(
              "div",
              { staticClass: "mb-3 flex items-center gap-2" },
              [
                _vm.activity.previous_status
                  ? _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlChip", {
                          attrs: { chip: _vm.activity.previous_status }
                        }),
                        _vm._v(" "),
                        _c("BlIcon", {
                          staticClass: "h-4 w-4",
                          attrs: { icon: "arrow-right", color: "slate-6" }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("BlChip", { attrs: { chip: _vm.activity.current_status } })
              ],
              1
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-363a2f29", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-363a2f29","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlActivity.vue
// module id = null
// module chunks = 